import { render, staticRenderFns } from "./medicalAssetList.vue?vue&type=template&id=4e241204&scoped=true&"
import script from "./medicalAssetList.vue?vue&type=script&lang=js&"
export * from "./medicalAssetList.vue?vue&type=script&lang=js&"
import style0 from "./medicalAssetList.vue?vue&type=style&index=0&id=4e241204&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e241204",
  null
  
)

export default component.exports